import merchantGatewayApi from 'apis/merchant-gateway/api';

import {
  CreateAndUpdateOfferCommissionResponse,
  CreateOfferCommissionPayload,
  DeleteOfferCommissionPayload,
  GetOfferCommissionsForVenueResponse,
  UpdateOfferCommissionPayload,
} from './types';

const OFFER_COMMISSIONS_SERVICE = '/offer-commissions-service';

export const getOfferCommissionsForVenue = (venueId: string) =>
  merchantGatewayApi
    .get<GetOfferCommissionsForVenueResponse>(`${OFFER_COMMISSIONS_SERVICE}/commissions?venue_id=${venueId}`)
    .then(res => res.data);

export const createOfferCommission = (payload: CreateOfferCommissionPayload) =>
  merchantGatewayApi
    .post<CreateAndUpdateOfferCommissionResponse>(`${OFFER_COMMISSIONS_SERVICE}/commissions`, payload)
    .then(res => res.data);

export const updateOfferCommission = (commissionId: string, payload: UpdateOfferCommissionPayload) =>
  merchantGatewayApi
    .put<CreateAndUpdateOfferCommissionResponse>(`${OFFER_COMMISSIONS_SERVICE}/commissions/${commissionId}`, payload)
    .then(res => res.data);

export const deleteOfferCommission = (commissionId: string, payload: DeleteOfferCommissionPayload) =>
  merchantGatewayApi
    .delete(`${OFFER_COMMISSIONS_SERVICE}/commissions/${commissionId}`, { data: payload })
    .then(res => res.data);
